//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {removeCredentials} from '@/utils/request'
import Vue from 'vue'
import { Menu,MenuItem, Submenu, MenuItemGroup,MessageBox } from "element-ui";
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.component(MessageBox.name, MessageBox);
export default {
  name: 'side-menu',
  components: {  },
  data() {
    return {
      avatar: '',
      name: '',
      subject: '',
      role: '',
      menu_index: '2'
    }
  },
  props: {
  },
  watch: {
    $route(to, from) {
      console.log('from',from.name,'to',to.name)
      window.is_editing = false
      this.loadMenuIndexWithName(to.name)
    }
  },
  methods: {
    loadMenuIndexWithName(routeName) {
      console.log('routeName', routeName)
      if (routeName == 'create_papers') {
        this.menu_index = '1-1'
      } else if (routeName == 'examination_papers') {
        this.menu_index = '1-2'
      } else if (routeName == 'examination_record') {
        this.menu_index = '1-3'
      } else if (routeName == 'exams') {
        this.menu_index = '2-1'
      } else if (routeName == 'publish_scores') {
        this.menu_index = '2-2'
      } else if (routeName == 'create_post') {
        this.menu_index = '3'
      } else if (routeName == 'preview_paper') {
        this.menu_index = ''
      }
    },
    logout() {
      MessageBox.confirm('退出登录后需要重新扫码才能继续使用', '是否退出登录', {
        confirmButtonText: '退出登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeCredentials()
        this.$message.success('退出登录成功')
        setTimeout(() => {
          const redirect = this.$router.resolve({name:'pc_login'})
          this.$router.open(redirect.href)
        }, 1000);
      }).catch(() => {
      });
    },
    openMenu(menu) {
      console.log('openMenu', menu)
      if (menu == 1) {
        this.selectMenu('1-2')
      } else if (menu == 2) {
        this.selectMenu('2-1')
      }
    },
    selectMenu(menu) {
      console.log('menu', menu, this.$route.name)
      if (menu == '1-1') {
        this.$router.push({name:'create_papers', query: {from: 'side-menu'}})
      } else if (menu == '1-2') {
        this.$router.push({name:'examination_papers', query: {from: 'side-menu'}})
      } else if (menu == '1-3') {
        this.$router.push({name:'examination_record', query: {from: 'side-menu'}})
      } else if (menu == '2-1') {
        this.$router.push({name:'exams', query: {from: 'side-menu'}})
      } else if (menu == '2-2') {
        this.$router.push({name:'publish_scores', query: {from: 'side-menu'}})
      } else if (menu == 3) {
        this.$router.push({name:'create_post', query: {from: 'side-menu'}})
      } else if (menu == 4) {
        this.$message('此功能暂未开放，敬请期待')
      } else if (menu == 5) {
        this.$router.open('https://aakit.cn/s/El86mpZJ9', true)
      }
      this.menu_index = menu
    }
  },
  mounted() {
    this.avatar = this.$store.getters.avatar
    this.name = this.$store.getters.realname
    var teacher_roles = this.$store.getters.teacher_roles
    for (let index = 0; index < teacher_roles.length; index++) {
      const role = teacher_roles[index];
      if (role.teacher_lists.length > 0) {
        var teacher = role.teacher_lists[0]
        this.role = teacher.is_admin?'班主任':''
        this.subject = teacher.role_call
        break
      }
    }
    this.loadMenuIndexWithName(this.$route.name)
  }
}



// WEBPACK FOOTER //
// ./src/components/pc/el-side-menu.vue